import { render, staticRenderFns } from "./OrganisationList.vue?vue&type=template&id=2196288e&scoped=true&"
import script from "./OrganisationList.vue?vue&type=script&lang=js&"
export * from "./OrganisationList.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrganisationList.vue?vue&type=style&index=1&id=2196288e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2196288e",
  null
  
)

export default component.exports